import type { TraffickingFilters } from '../../../../apis/graphql/types';

const CASE_SENSITIVE_FILTER_KEYS: Record<string, string> = {
  cpm: 'CPM',
};

function kebabToCamel(str: string): string {
  return str.replace(/-([a-z])/g, (_, char) => char.toUpperCase());
}

export function normalizeFilterPayloadKeys(payload: TraffickingFilters): TraffickingFilters {
  const normalized: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(payload)) {
    const camelKey = kebabToCamel(key);
    const correctedKey = CASE_SENSITIVE_FILTER_KEYS[camelKey] ?? camelKey;
    normalized[correctedKey] = value;
  }
  return normalized as TraffickingFilters;
}
